import classNames from 'classnames';
import React from 'react';
import './FormHeader.scss';

interface IProps {
  formName: string;
  className?: string;
}

const FormHeader = ({ formName, className }: IProps) => (
  <div className={classNames('FormHeader', 'pt-3', className)}>
    <h2 className="FormHeader-name text-start fontweight-bold">{formName}</h2>
  </div>
);

export default FormHeader;
